// ============================================
// CORRECTED ROUTER - router/index.js
// ============================================
// Key fix: Route names must match what existing components use
// ProjectContext.vue uses { name: 'CandidatePool' }

import { createRouter, createWebHashHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import HistoryView from '@/views/HistoryView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/bookmarks',
    name: 'bookmarks',
    component: () => import('../views/BookmarksView.vue')
  },
{
  path: '/history',
  name: 'history',
  component: HistoryView,
  meta: { requiresAuth: true }
},
  {
    path: '/admin',
    name: 'admin',
    component: () => import('../views/AdminDashboard.vue'),
    meta: { requiresAdmin: true }
  },
  {
    path: '/change-password',
    name: 'change-password',
    component: () => import('../components/PasswordChangePage.vue'),
    meta: { requiresPasswordChallenge: true }
  },
  
  // ✅ Agent Projects Dashboard
  {
    path: '/agent/projects',
    name: 'agent-projects',
    component: () => import('../views/AgentProjectsView.vue'),
    meta: { requiresAgent: true }
  },
  {
    path: '/client/projects',
    name: 'client-projects',
    component: () => import('../views/ClientProjectsView.vue'),
    meta: { requiresAuth: true }
  },  
  
  // ✅ Candidate Pool Metrics (agent metrics page) - different feature
  {
    path: '/candidate-pool',
    name: 'candidate-pool-metrics',
    component: () => import('../views/CandidatePoolMetrics.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/nl-test',
    name: 'NLSearchTest',
    component: () => import('@/components/NLSearchTestPanel.vue')
  },
 
  // ✅ Project Candidate Pool (view candidates in a specific project)
  // CRITICAL: Name must be 'CandidatePool' to match ProjectContext.vue line 324
  {
    path: '/project/:projectId/pool',
    name: 'CandidatePool',  // <-- Must match existing code in ProjectContext.vue!
    component: () => import('../views/CandidatePool.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/project/:project_id/pool',
    name: 'project-pool',
    component: () => import('../views/CandidatePool.vue')
  }
]
 
const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes
})

export default router